import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Dialog from '@material-ui/core/Dialog';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import { Colors } from '../../themes';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'scroll',
  },
  paper: {
    color: Colors.black,
    background: Colors.white,
    borderRadius: 4,
    padding: theme.spacing(4),
    boxShadow: theme.shadows[5],
    outline: 'none',
  },
  fullScreenPaper: {
    borderRadius: 0,
  },
}));

export default function CustomModal(props) {
  const classes = useStyles();
  const { open, handleClose, Content } = props;
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));

  return (
    <div>
      <Dialog
        fullScreen={fullScreen}
        maxWidth={'xl'}
        scroll={'body'}
        aria-labelledby="modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className={clsx(classes.paper, fullScreen && classes.fullScreenPaper)}>
            <Content {...props} onClose={handleClose} />
          </div>
        </Fade>
      </Dialog>
    </div>
  );
}
